/** Ações de editar/excluir um tipo de acordo */
import React, { Component } from "react";
import {
  Button,
  Icon,
  Modal,
  Checkbox,
  notification,
  Popconfirm,
  Input
} from "antd";

import api from "../../../../../services/api";

import PropTypes from "prop-types";

export default class Actions extends Component {
  static propTypes = {
    tipo: PropTypes.object,
    handleTypes: PropTypes.func
  };

  state = {
    loading: false,
    visible: false,
    sucumbencial: this.props.tipo.honorarios_sucumbenciais,
    porcentage:
      this.props.tipo.porcentagem_honorarios == null
        ? 0
        : this.props.tipo.porcentagem_honorarios
  };

  handleEdit = () => {
    this.setState({
      visible: true
    });
  };

  handleClose = () => {
    this.setState({
      visible: false
    });
  };

  handlePorcentChange = event => {
    this.setState({
      porcentage: event.target.value
    });
  };

  handleCheckboxChange = event => {
    this.setState({
      sucumbencial: event.target.checked
    });
  };

  handleDelete = async () => {
    await api
      .delete(`/tipo_acordo/${this.props.tipo.id}/`)
      .then(() => {
        notification.success({
          message: "Deletado."
        });

        this.props.handleTypes();
      })
      .catch(err => {
        if (err.response) {
          if (err.response.status == 400) {
            Modal.error({
              title: "Erro",
              content: err.response.data.message
            });
          }
        }
      });
  };

  handleSave = async () => {
    const porcentagem_honorarios = this.state.porcentage;
    const honorarios_sucumbenciais = this.state.sucumbencial;

    if (/[^0-9,.]/g.test(porcentagem_honorarios)) {
      Modal.error({
        title: "Erro",
        content: "Porcentagem inválida!"
      });
      return;
    }

    const porcentage = String(porcentagem_honorarios).replace(/[,]/g, ".");

    if (isNaN(parseFloat(porcentage))) {
      Modal.error({
        title: "Erro",
        content: "Porcentagem inválida!"
      });
      return;
    }

    if (parseFloat(porcentage) > 100 || parseFloat(porcentage) < 0) {
      Modal.error({
        title: "Erro",
        content: "Porcentagem inválida!"
      });
      return;
    }

    this.setState({
      loading: true
    });

    await api
      .put(`/tipo_acordo/${this.props.tipo.id}/`, {
        porcentagem_honorarios: parseFloat(porcentage),
        tipo: document.getElementById("tipo").value
      })
      .then(() => {
        notification.success({
          message: "Informações salvas."
        });

        this.props.handleTypes();

        this.setState({
          visible: false
        });
      })
      .catch(err => {
        console.log(err);

        Modal.error({
          title: "Erro",
          content: "Ocorreu um erro."
        });
      });

    this.setState({
      loading: false
    });
  };

  render() {
    return (
      <div>
        <Button type="primary" size="small" onClick={this.handleEdit}>
          <Icon type="edit" />
        </Button>
        &nbsp;&nbsp;
        <Popconfirm
          title="Você tem certeza?"
          okText="Confirmar"
          cancelText="Cancelar"
          onConfirm={this.handleDelete}
        >
          <Button type="danger" size="small">
            <Icon type="delete" />
          </Button>
        </Popconfirm>
        <Modal
          visible={this.state.visible}
          title="Editar"
          confirmLoading={this.state.loading}
          okText="Salvar"
          cancelText="Cancelar"
          onOk={this.handleSave}
          onCancel={this.handleClose}
        >
          <div>
            <label>Tipo do acordo:</label>
            <Input
              id="tipo"
              style={{ marginTop: "5px" }}
              type="text"
              defaultValue={this.props.tipo.tipo}
            />
          </div>
          <br />
          <div style={{ display: "flex" }}>
            <div style={{ width: "50%" }}>
              <label>Porcentagem honorários:</label>
              <input
                style={{ marginTop: "5px" }}
                type="text"
                className="ant-input"
                value={this.state.porcentage}
                onChange={this.handlePorcentChange}
              />
            </div>
            <div style={{ width: "50%", marginLeft: "15px" }}></div>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Configuracoes/Acordo/TiposAcordo/Actions/index.js